import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import SellIcon1 from "../assets/images/sell-icon-1.svg";
import SellIcon2 from "../assets/images/sell-icon-2.svg";
import ArrowIcon from '../assets/images/button-arrow.svg';
import { Link } from "react-router-dom"
import {ASSETS_URL} from "../api/constants";

const SellWithAgent = ({ data, loading }) => {
  return (
    <div className="why-pre-qualified common-padding">
      <Container>
        <div className="common-header text-center">
          <h2 dangerouslySetInnerHTML={{ __html: data?.title || "" }} />
          <p>{data?.subtitle || ""}</p>
        </div>

        <Row className="g-4 justify-content-center">
          {(data?.cards || []).map((card, index) => (
            <Col key={index} md={6} lg={5}>
              <Card>
                <img src={`${ASSETS_URL}${card.icon}`} alt="" />
                <h5>{card.title}</h5>
                <p>{card.subtitle}</p>
              </Card>
            </Col>
          ))}
        </Row>

        <div className="d-flex justify-content-center mt-4 mt-lg-5">
          <Link to={data?.btn_link || '/find-an-agent'} className="custom-bttn style-3 ani-1 right">
            {data?.btn_name || "Get Started"} <img src={ArrowIcon} alt="Arrow Icon" />
          </Link>
        </div>
      </Container>
    </div>
  );
};

export default SellWithAgent;
